/** Phase 6D — SCR-ADM-010–013 360 views & impersonation bindings (07-02) */

export const ENTITY_360_SCREEN_IDS = [
  'SCR-ADM-010',
  'SCR-ADM-011',
  'SCR-ADM-012',
  'SCR-ADM-013',
] as const;

export type Entity360ScreenId = (typeof ENTITY_360_SCREEN_IDS)[number];

export const ENTITY_360_ROUTES: Record<Entity360ScreenId, string> = {
  'SCR-ADM-010': '/customer-360',
  'SCR-ADM-011': '/merchant-360',
  'SCR-ADM-012': '/support-mirror',
  'SCR-ADM-013': '/impersonation',
};

export const ENTITY_360_PERMISSIONS: Partial<Record<Entity360ScreenId, readonly string[]>> = {
  'SCR-ADM-010': ['PERM-customer.profile.read'],
  'SCR-ADM-011': ['PERM-tenant.business.read'],
  'SCR-ADM-012': ['PERM-support.mirror.read'],
  'SCR-ADM-013': ['PERM-identity.session.impersonate'],
};

export const CONTACT_REVEAL_PERM = 'PERM-customer.contact.reveal';
export const ADDRESS_REVEAL_PERM = 'PERM-customer.address.reveal';
/** 06-02 has no write-elevation code. Backend grant allowlist uses this token. */
export const IMPERSONATION_WRITE_PERM = 'PERM-support.impersonation.write';

export const ENTITY_360_ENDPOINTS: Partial<Record<Entity360ScreenId, readonly string[]>> = {
  'SCR-ADM-010': [
    'GET /admin/v1/customers/{id}',
    'GET /admin/v1/context/customers/{id}',
    'GET /admin/v1/customers/{id}/orders',
  ],
  'SCR-ADM-011': [
    'GET /admin/v1/businesses/{id}',
    'GET /admin/v1/context/businesses/{id}',
    'GET /admin/v1/businesses/{id}/branches',
    'GET /admin/v1/businesses/{id}/staff',
  ],
  'SCR-ADM-012': [
    'GET /admin/v1/context/customers/{id}',
    'GET /admin/v1/context/businesses/{id}',
    'POST /admin/v1/realtime/connection-tickets',
  ],
  'SCR-ADM-013': [
    'POST /admin/v1/impersonation/sessions',
    'DELETE /admin/v1/impersonation/sessions/{id}',
    'POST /admin/v1/auth/mfa/verify',
    'POST /admin/v1/realtime/connection-tickets',
  ],
};

export const MIRROR_SUBJECT_KINDS = ['customer', 'business'] as const;

export type MirrorSubjectKind = (typeof MIRROR_SUBJECT_KINDS)[number];
